export default function WelcomeOverlay({ name }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#05070B]" data-testid="welcome-overlay">
      <div className="animate-fade-up text-center">
        <div className="mx-auto mb-6 h-16 w-16 rounded-2xl border border-cyan-400/30 bg-cyan-500/10 flex items-center justify-center">
          <span className="font-heading text-2xl font-bold text-cyan-400">{(name || "A")[0].toUpperCase()}</span>
        </div>
        <h1 className="font-heading text-3xl font-bold text-white">Bienvenue 👋</h1>
        <p className="mt-2 text-slate-400">Votre cockpit automobile est prêt{name ? `, ${name.split(" ")[0]}` : ""}.</p>
        <div className="mx-auto mt-8 h-0.5 w-40 overflow-hidden rounded bg-white/10">
          <div className="h-full w-full origin-left animate-[welcomebar_1.6s_ease-in-out_forwards] bg-cyan-400" />
        </div>
      </div>
    </div>
  );
}
